import { render, staticRenderFns } from "./BuyTime.vue?vue&type=template&id=1ef96c2c&scoped=true"
import script from "./BuyTime.vue?vue&type=script&lang=js"
export * from "./BuyTime.vue?vue&type=script&lang=js"
import style0 from "./BuyTime.vue?vue&type=style&index=0&id=1ef96c2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef96c2c",
  null
  
)

export default component.exports